export default __webpack_public_path__ + "static/media/39_desktop.692af6ac.jpeg";